import { useCallback, useEffect, useState } from 'react';

const kept = new Map<string, boolean>();

const isInside = (pathname: string, sectionPaths: string[]): boolean =>
  sectionPaths.some(path => pathname === path || pathname.startsWith(`${path}/`));

/** A yes/no kept while the user moves between a section's pages, and back to `fallback` once they leave it or reload. */
export const useSectionToggle = (
  key: string,
  sectionPaths: string[],
  fallback = false,
): [boolean, (value: boolean) => void] => {
  const [checked, setChecked] = useState(() => kept.get(key) ?? fallback);

  const set = useCallback(
    (value: boolean) => {
      setChecked(value);
      kept.set(key, value);
    },
    [key],
  );

  const sectionKey = sectionPaths.join('|');
  useEffect(
    // On unmount the router has already moved, so the address says whether the user left the section.
    () => () => {
      if (!isInside(window.location.pathname, sectionKey.split('|'))) kept.delete(key);
    },
    [key, sectionKey],
  );

  return [checked, set];
};
